import MainLayout from './templates/Layout/MainLayout/MainLayout.vue'
import MenuBarLayout from './templates/Layout/MenuBarLayout/MenuBarLayout.vue'
import MobileLayout from './templates/Layout/MobileLayout/MobileLayout.vue'
import ToolbarLayout from './templates/Layout/ToolbarLayout/ToolbarLayout.vue'

import CardTemplate from './templates/Pages/CardTemplate/CardTemplate.vue'
import InitialTemplate from './templates/Pages/InitialTemplate/InitialTemplate.vue'
import SidebarTemplate from './templates/Pages/SidebarTemplate/SidebarTemplate.vue'
import SimpleCardTemplate from './templates/Pages/SimpleCardTemplate/SimpleCardTemplate.vue'
import TabsCardTemplate from './templates/Pages/TabsCardTemplate/TabsCardTemplate.vue'

export const zMainLayout = MainLayout
export const zToolbarLayout = ToolbarLayout
export const zMobileLayout = MobileLayout
export const zMenuBarLayout = MenuBarLayout
export const zSidebarTemplate = SidebarTemplate
export const zCardTemplate = CardTemplate
export const zSimpleCardTemplate = SimpleCardTemplate
export const zInitialTemplate = InitialTemplate
export const zTabsCardTemplate = TabsCardTemplate
